import React from 'react'
import Header from '../../components/Header/Header';
import DonationSchemes from '../../components/DonationSchemes/DonationSchemes';


function WaqfDetailsPage() {
  return (
    <Header activeRoute="/">
      <DonationSchemes/>
    </Header>
  )
}

export default WaqfDetailsPage
